import { Box } from '@eatclubcode/ec-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './AppUpdateBarStyles';

const AppUpdateBar = ({ hasUpdate }) => {
  const classes = useStyles();

  if (!hasUpdate) {
    return <></>;
  }

  return (
    <Box
      className={classes.appUpdateBar}
      onClick={() => {
        window.location.reload();
      }}
    >
      A new app update is available. Please click here to reload the page.
    </Box>
  );
};

AppUpdateBar.propTypes = {
  hasUpdate: PropTypes.bool.isRequired,
};

export default AppUpdateBar;
